import InvoicingDetailsOverview from './InvoicingDetailsOverview';

export default InvoicingDetailsOverview;
